import { useState, useEffect, useCallback } from "react";
import { ROUTES } from "./app/mobile-routes";

const MOBILE_BREAKPOINT = 1024;

export const getPath = (routeKey: keyof typeof ROUTES): string => {
  return isMobileCheck() ? ROUTES[routeKey].mobile : ROUTES[routeKey].desktop;
};

export const isMobileCheck = (): boolean =>
  typeof window !== "undefined" && window.innerWidth < MOBILE_BREAKPOINT;

export const getPathStatic = (
  routeKey: keyof typeof ROUTES,
  isMobile: boolean
): string => {
  return isMobile ? ROUTES[routeKey].mobile : ROUTES[routeKey].desktop;
};

/**
 * Подставляет параметры в путь вида:
 * "/mobile/kpi/kpiList/:entityId?" => "/mobile/kpi/kpiList/123"
 */
export const buildPath = (
  pathTemplate: string,
  params: Record<string, string | number | undefined>
): string => {
  return pathTemplate.replace(/:([a-zA-Z0-9_]+)\??/g, (_, key) => {
    const value = params[key];
    return value !== undefined ? encodeURIComponent(String(value)) : "";
  });
};

export const usePath = () => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? isMobileCheck() : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isMobileCheck());
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // сразу вызываем при монтировании

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getPath = useCallback(
    (routeKey: keyof typeof ROUTES): string =>
      getPathStatic(routeKey, isMobile),
    [isMobile]
  );

  return {
    isMobile,
    getPath,
    buildPath,
  };
};
